export default function ContactHero() {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-32">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.1),transparent)]"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">Let's Connect</h1>
        <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
          Have a project in mind or just want to say hello? I'd love to hear from you.
        </p>
      </div>
    </section>
  );
}
